import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader"
}
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" NOTE: we do this the hard way -> these are appanded to the root div the app is mounted on, so we dont have 2 divs in each other \n      <div\n    class=\"stm-toolbar-button tabToolbarButton tab-widget lineage\"\n    :class=\"classes\"\n    tabindex=\"-1\"\n    aria-expanded=\"false\"\n    role=\"button\"\n    :title=\"info.text\"\n    @click=\"buttonClicked\"\n    ref=\"btn\"\n  > "),
    ($setup.isLoading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _createVNode($setup["LoadingGif"])
        ]))
      : (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "icon",
          innerHTML: $props.info.svgXml,
          style: $setup.svgStyles
        }, null, 8 /* PROPS */, _hoisted_2)),
    _createElementVNode("span", {
      ref: "btnText",
      class: "text"
    }, _toDisplayString($props.info.text), 513 /* TEXT, NEED_PATCH */),
    _createCommentVNode(" </div> ")
  ], 64 /* STABLE_FRAGMENT */))
}